<template>
    <div class="popup">
        <div class="popup-inner">
            <div class="row" style="padding:20px;">
                <div class="col-md-12 text-center">
                    <h5 style="font-size: 1rem; font-weight: 600; color:#48A6A6;">Download Attachments</h5>
                </div>
                <!-- <div class="col-md-2 text-right" style="margin-top: -25px;">
                    <i @click="close" class="fa fa-times-circle" style="font-size:19px;color:#a70909;"></i>
                </div> -->
            </div>
          
            <!-- <div v-for="(attachment,index) in attachments" :key="index"> -->
                <ul style="list-style-type: disclosure-closed;padding-left: 40px;">
                                        <li v-for="(attachment,i) in attachments" :key="i">
                                          <a class="dropdown-item" style="text-decoration:none;" :href="aws_base_path+attachment['path']+attachment['file_name']" target="_blank">File {{i+1}} <i style="color:#48a6a6;" class="fa fa-download pl-2" aria-hidden="true"></i></a>
                                        </li>
                                       
                                      </ul>
        <div style="margin-bottom: 2rem;">
            <button type="button" class="btn btn-secondary btn-sm float-right close-btn" @click="close" >Close</button>
        </div>
                <!-- </div>  -->
        </div>
    </div>
</template>
<script>
export default {
    props: ["attachments","aws_base_path"],
    data: function () {
      return {
        attachmets_download: {},
      }
    },
    mounted:function(){
        console.log("popup",this.attachments);
    },
    methods:{
        close(){
            $('.content-wrapper').css('height','auto');
            $('.content-wrapper').css('overflow-y','auto');
            this.$emit('setVisibility',false);
        }
    },
    watch:{
        attachments: function (val) {
            this.attachments_download = val;
            return val;
        }
    }
}
</script>
<style lang="scss" scoped>
.popup{
    position:fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    z-index: 99;
    background-color: rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    .popup-inner{
        background: #FFF;
        padding:   20px;
        width: 16%;
        ul{
            max-height: 300px;
            overflow-y: auto;
            
        }
    }
}
ul::-webkit-scrollbar {
  width: 5px !important;
}

ul::-webkit-scrollbar-thumb {
  background-color: rgb(160 180 194);
  border-radius: 15px;

}

ul::-webkit-scrollbar-track {
  /*background-color: grey;*/
  box-shadow: inset 0 0 5px rgb(225 230 245);
  border-radius: 15px;
}
.dropdown-item:active{
    background-color: #48a6a6;
    >.fa-download{
        color:#FFF !important;
    }
}
.close-btn:active,.close-btn:hover{
    color: #6c757d !important;
}
</style>